import React from 'react'
import OptionalContentImage from './OptionalContentImage';

const UserMessage = (props) => {
    const responseImage = (props.myData.is_solution_on_click || props.myData.show_response_img) ? props.myData.response_img : null;

    return (
        <section>
            <div
                style={{
                    backgroundColor: "#a2e7a2",
                    width: responseImage ? "min(320px, 60%)" : "fit-content",
                    minWidth: "20%",
                    maxWidth: "60%", 
                    paddingTop: "1px",
                    paddingLeft: "15px",
                    paddingBottom: "5px", 
                    paddingRight: "10px", 
                    borderTopLeftRadius: "10px", 
                    borderBottomLeftRadius: "10px",
                    fontFamily: "Merriweather", 
                    marginTop: "15px", 
                    marginLeft: "auto", 
                    marginRight: "10px", 
                    borderTopRightRadius: "10px"
                }}>
                <OptionalContentImage src={responseImage} />
                <p style={{ fontSize: "14px" }} key={Math.random()}>{props.myData.response_user}</p>
            </div>
        </section>
    )
}

export default UserMessage
